module.exports = __webpack_public_path__ + "static/media/view2.799953b2.jpg";